import React from 'react'
import './CollectionPayge.css'
import axios from 'axios'
import { Helmet } from 'react-helmet'
import { Document, Page } from 'react-pdf/dist/entry.webpack'
import driveLogo from '../../assets/img/googledrive.png'

import Unsplash from 'unsplash-js'
import GooglePicker from 'react-google-picker'
import DropboxChooser from 'react-dropbox-chooser'
import * as firebase from "firebase/app"
import "firebase/auth"

import { API_URL } from '../../config'
import { themeColors } from '../../constants'
import PaygeItem from '../../components/PaygeItem/PaygeItem'
import { ArrowForward, Add, Close, CheckCircle, ArrowDownward, Delete } from '@material-ui/icons'
import CollectionItem from '../../components/CollectionItem/CollectionItem'

const dummy_downloads = [
  {name: 'Download Name'},
  {name: 'New File'},
  {name: 'English Book'},
  {name: 'Physics Book'},
  {name: 'Denmark Name'},
  {name: 'Vrerjk Name'},
  {name: 'Download Name'},
  {name: 'Download Name'},
  {name: 'Qwert Name'},
  {name: 'Porfkd Name'},
  {name: 'Download Name'},
  {name: 'GFgj Name'},
  {name: 'Shibin.co Name'},
  {name: 'Yousf Name'},
  {name: 'Chummar Name'},
  {name: 'Tatt Name'},
  {name: 'Nofo Name'},
]

const options = {
  cMapUrl: 'cmaps/',
  cMapPacked: true,
}
const img_one = "https://images.unsplash.com/photo-1562663474-6cbb3eaa4d14?ixlib=rb-1.2.1&q=85&fm=jpg&crop=entropy&cs=srgb&ixid=eyJhcHBfaWQiOjEyODM3M30"
// const img_one = "https://images.unsplash.com/photo-1561016444-14f747499547?ixlib=rb-1.2.1&ixid=eyJhcHBfaWQiOjEyMDd9&auto=format&fit=crop&w=1489&q=80"
const default_background = {
  urls: {
    full: '',
    small: '',
  },
  user: {
    name: "...",
    links: { html: "#" }
  }
}

export default class CollectionPayge extends React.Component {

  constructor(props) {
    super(props)
    this.state = {
      isLoaded: false,
      paygeData: undefined,
      isBackgroundLoaded: false,
      isLinkCopied: false,
    }
  }

  // copying to clipboard
  copyLinkToClipboard = () => {
    let context = this
    let link = `https://payge.io/pro/${this.props.match.params.payge_id}`
    navigator.permissions.query({name: "clipboard-write"}).then(result => {
      if (result.state == "granted" || result.state == "prompt") {
        // writing link to clipboard
        navigator.clipboard.writeText(link).then(function() {
          console.log("clipboard copied")
          // quick UI changes
          context.showCopyUIChanges()
        }, function() {
          console.log("clipboard error")
        });
      }
    });
  }
  showCopyUIChanges = () => {
    this.setState({isLinkCopied: true})
    setTimeout(() => {
      this.setState({isLinkCopied: false})
    }, 700)
  }

  componentWillMount() {
    if (this.props.isEditing) { return }

    let paygeID = this.props.match.params.payge_id
    // showing loading indicator
    this.setState({isLoaded: false})
    console.log(paygeID)
    // getting payge details
    axios(`${API_URL}/payge/${paygeID}`)
      .then((result) => {
        if (result.status === 200) {
          if (result.data.status === "success") {
            document.title = `${result.data.payge.paygeDetails.name} - Payge`
            this.setState({
              paygeData: result.data.payge,
              isLoaded: true
            })
            // setting up google analytics
            if (result.data.payge.paygeDetails.gAnalyticsTrackingId) {
              this.setupGoogleAnalyticsForUser(result.data.payge.paygeDetails.gAnalyticsTrackingId)
            }
          }
        }
      })
  }

  // Adding Google Analytics with User's tracking Id
  setupGoogleAnalyticsForUser(gAnalyticsTrackingId) {
    // adding scripts
    const script = document.createElement("script")
    script.src = `https://www.googletagmanager.com/gtag/js?id=${gAnalyticsTrackingId}`
    script.async = true
    document.body.appendChild(script)
    
		const gScriptTag = document.createElement("script")
    gScriptTag.innerHTML = 
    `
    window.dataLayer = window.dataLayer || [];
    function gtag(){dataLayer.push(arguments);}
    gtag('js', new Date());

    gtag('config', '${gAnalyticsTrackingId}');
    `
    gScriptTag.async = true
    document.body.appendChild(gScriptTag)
  }

  render() {
    const { isLoaded, paygeData, isBackgroundLoaded, isLinkCopied } = this.state
    let { isEditing, isPublishError } = this.props

    // loading
    let isLoading = isEditing ? this.props.isLoading : !isLoaded

    // getting payge data
    let collectionTitle = isEditing ? this.props.collectionTitle : 'Loading...'
    let collectionDescription = isEditing ? this.props.collectionDescription : 'Loading...'
    let downloads = isEditing ? this.props.downloads : []
    let currentThemeColorName = isEditing ? this.props.themeColorName : themeColors[0].name
    let collectionViewStyle = isEditing ? this.props.collectionViewStyle : 'grid'
    let collectionLogo = isEditing ? this.props.collectionLogo : undefined
    let isJustCreated = false
    if (paygeData) {
      let paygeDetails = paygeData.paygeDetails
      collectionTitle = paygeDetails.name
      collectionDescription = paygeDetails.description
      collectionLogo = paygeDetails.logoUrl
      downloads = paygeData.files
      currentThemeColorName = paygeDetails.themeColor
      collectionViewStyle = paygeDetails.viewStyle
      // checking if payge is just created
      let new_payge_tag = new URLSearchParams(this.props.location.search).get('new_payge')
      if (paygeData.viewCount === 0 && new_payge_tag) {
        isJustCreated = true
      }
    }
    let currentThemeColor = themeColors[0]
    themeColors.map(color => {
      if (color.name == currentThemeColorName) { currentThemeColor = color }
    })
    let title_max_length = 88
    let des_max_length = 145
    collectionTitle = collectionTitle && collectionTitle.trim() !== '' && collectionTitle.length > title_max_length ? 
      collectionTitle.substring(0, title_max_length-3) + '...' : collectionTitle
    collectionDescription = collectionDescription && collectionDescription.trim() !== '' && collectionDescription.length > des_max_length? 
      collectionDescription.substring(0, des_max_length-3) + '...' : collectionDescription

    return (
      <div className="respayge app" style={{background: `rgb(${currentThemeColor.color[0]},${currentThemeColor.color[1]}, ${currentThemeColor.color[2]}, 0.03)`}}>

        <div id="res-content">
          <div 
            className="bg-img"
            style={{
              background: `rgb(${currentThemeColor.color[0]},${currentThemeColor.color[1]}, ${currentThemeColor.color[2]})`,
              background: `linear-gradient(180deg, 
                rgba(${currentThemeColor.gradient[0][0]},${currentThemeColor.gradient[0][1]}, ${currentThemeColor.gradient[0][2]}, ${currentThemeColor.gradient[0][3]}) 0%, 
                rgba(${currentThemeColor.gradient[1][0]},${currentThemeColor.gradient[1][1]}, ${currentThemeColor.gradient[1][2]}, ${currentThemeColor.gradient[1][3]}) 35%, 
                rgba(${currentThemeColor.gradient[2][0]},${currentThemeColor.gradient[2][1]}, ${currentThemeColor.gradient[2][2]}, ${currentThemeColor.gradient[2][3]}) 100%)`
            }} />
          <div className="res-content-card">
            <div className="top-container">
              {
                isEditing && !collectionLogo ? (
                  <>
                    <input 
                      type="file" 
                      accept="image/x-png,image/gif,image/jpeg"
                      onChange={(e)=>this.props.handleCollectionLogoChange(e)} style={{display:'none'}}
                      ref={(ref) => this.logoInput = ref} />
                    <div className="add-logo-container res-logo" type="submit" onClick={()=>this.logoInput.click()}>
                      <Add className="icon"/>
                    </div>
                  </>
                ) : isEditing && collectionLogo ? (
                  <>
                    <input type="file" onChange={(e)=>this.props.handleCollectionLogoChange(e)} style={{display:'none'}}
                      ref={(ref) => this.logoInput = ref} />
                    <img src={URL.createObjectURL(collectionLogo)} className="res-logo hoverable" onClick={()=>this.logoInput.click()} />
                  </>
                ) : collectionLogo ? (
                  <img src={collectionLogo} className="res-logo" />
                ): false
              }

              <div className="top-text-container">
                {
                  isEditing ? (
                    <>
                      <input 
                        className="top-text-title free-input" 
                        value={collectionTitle}
                        onChange={(e)=>this.props.handleCollectionTitleChange(e.target.value)}
                        placeholder="Type your Payge title here..." />
                      <input 
                        className="top-text-description free-input" 
                        value={collectionDescription}
                        onChange={(e)=>this.props.handleCollectionDescriptionChange(e.target.value)}
                        placeholder="Type in a description for the download collection here..." />
                    </>
                  ) : (
                    <>
                      <div 
                        className="top-text-title" 
                        contentEditable={isEditing}
                        placeholder="Type your Payge title here...">
                        {collectionTitle}
                      </div>
                      <div 
                        className="top-text-description" 
                        contentEditable={isEditing}
                        placeholder="Type in a description for the download collection here...">
                        {collectionDescription}
                      </div>
                    </>
                  )
                }
              </div>
            </div>
            <span className="downloads-title">Downloads</span>
            <ul className={`downloads ${collectionViewStyle}`}>
              {
                isEditing ? (
                  <li className="item new">
                    <span className="add-files-text">Add new files</span>
                    <ul className="res-file-providers">
                      <GooglePicker 
                        clientId={'678604044547-incnhojndefjdjv63md3fsbk5vo0ccvc.apps.googleusercontent.com'}
                        developerKey={'AIzaSyDrDdmRMzPZdInG6O9uTVrfslh82gXBcAc'}
                        scope={['https://www.googleapis.com/auth/drive.file']}
                        onChange={data => this.props.onDriveSelectDataChange(data)}
                        onAuthFailed={data => console.log('on auth failed:', data)}
                        multiselect={true}
                        navHidden={false}>
                        <li className={`first`}>
                          <img src={driveLogo}/>
                          <span>Google Drive</span>
                        </li>
                      </GooglePicker>
                      <DropboxChooser 
                        appKey={'cjwxs1ps6pj49sq'}
                        success={files => this.props.onDropboxChooseDataChange(files)}
                        linkType={'direct'}
                        multiselect={true} >
                        <li className={`last`}>
                          <img src={"https://cfl.dropboxstatic.com/static/images/logo_catalog/dropbox_logo_glyph_m1.svg"}/>
                          <span>Dropbox</span>
                        </li>      
                      </DropboxChooser>
                    </ul>
                  </li>
                ) : false
              }
              {
                downloads.map((download) => (
                    <CollectionItem 
                      key={download.id}
                      download={download}
                      currentThemeColor={currentThemeColor}
                      currentViewStyle={collectionViewStyle}
                      handleFileNameChange={this.props.handleFileNameChange}
                      handleFileRemove={this.props.handleFileRemove}
                      isEditing={isEditing}
                      paygeId={isEditing ? undefined : this.props.match.params.payge_id} />
                  )
                )
              }
            </ul>
          </div>
        </div>

        {
          isJustCreated ? (
            <div className="created-banner">
              <CheckCircle className="icon" />
              <span className="done-text">Start sharing your newly created Collection Payge!</span>
              <span className="copy-btn" onClick={this.copyLinkToClipboard.bind(this)}>{ isLinkCopied ? 'Copied' : 'Copy Link to Clipboard'}</span>
            </div>
          ): false
        }
        
      </div>

    )
  }

}